import { FlexBox } from '@fable/components'
import { css, cx } from '@fable/theme'
import { useStats } from '../../lib/ctx/stats'
import { ReaderStatCards } from './ReaderStatCards'
import { ReaderSummaryShareButtons } from './ReaderSummaryShareButtons'
import { motion } from 'framer-motion'
import { useStatCards } from './useStatCards'
import { ReaderSummaryContainer } from './ReaderSummaryContainer'
import { useDeviceDetect } from '@fable/hooks'
import { useReaderSummary } from '../../lib/ctx/reader_summary'
import { ReaderSummary } from './ReaderSummary'

export const StatsReaderSummary = () => {
  const [stats, theme, isProfileView, goalOptIn, isV2, isSelfView] = useStats(
    (s) => [
      s.stats,
      s.theme,
      s.isProfileView,
      s.goalOptIn,
      s.isV2,
      s.isSelfView,
    ]
  )
  const [status, summary] = useReaderSummary((s) => [s.status, s.summary])
  const statCards = useStatCards()
  const { isMobile } = useDeviceDetect()

  const loading = status === 'loading'
  const isSummaryView = status === 'summary'

  const hasGoal = !!stats?.reading_goal
  const isV2GoalOptIn = isV2 ? goalOptIn : true
  const isGoalValid = hasGoal && isV2GoalOptIn
  const shouldShowButtons = isSelfView && isMobile && isGoalValid

  const topSpacing = () => {
    if (!isV2GoalOptIn && (isSummaryView || loading)) return 20
    return 0
  }

  return (
    <ReaderSummaryContainer>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.4, ease: 'easeInOut' }}
        className={css`
          padding-top: ${topSpacing()}px;
          width: 100%;
        `}
      >
        <FlexBox
          data-testid="stats-reader-summary"
          className={cx(
            css`
              position: relative;
              width: 100%;
              border-radius: 20px;
              gap: 12px;
              transition: background-color ease-in-out 0.3s, color 0.3s;
              background-color: ${isSummaryView
                ? theme.primary
                : 'transparent'};
            `,
            isSummaryView
              ? css`
                  padding: ${!isProfileView
                    ? '12px 12px 32px 12px'
                    : '12px 0 0 0'};
                `
              : css`
                  padding-bottom: ${!isProfileView && isGoalValid
                    ? '20px'
                    : '0'};
                `
          )}
          flexDirection="column"
          alignItems="center"
        >
          <ReaderSummary />
          {isGoalValid && (
            <div
              data-testid="stats-reader-summary-stat-cards"
              className={cx(
                css`
                  width: 100%;
                  margin-top: 16px;
                `
              )}
            >
              <ReaderStatCards statCards={statCards} />
            </div>
          )}
          {shouldShowButtons ? (
            <FlexBox
              className={css`
                width: 100%;
              `}
              justifyContent="center"
            >
              <ReaderSummaryShareButtons
                theme={theme}
                summary={summary}
                loading={loading}
                // hardcoded to false when pulling reader summary feature
                canShareStats={false}
                canEditGoal={isGoalValid}
              />
            </FlexBox>
          ) : null}
        </FlexBox>
      </motion.div>
    </ReaderSummaryContainer>
  )
}
